import {
  TextInput,
  SelectInput,
  NumberInput,
  AutocompleteArrayInput
} from 'react-admin';
import { eventNames } from '../../helpers/constants';
import {
  dataSourceOptions,
  PROCESS_STATUSES,
  PLATFORM_TYPE_CHOICES
} from '../../config/constants/apiConstants';

export const getMetaApiDataFilters = (accounts) => [
  <TextInput
    source="q"
    label="ID, Pixel ID, Settings ID, Transaction ID, Campaign ID, Order ID, Event ID"
    alwaysOn
    sx={{ width: '700px' }}
  />,
  <SelectInput
    source="data_source"
    label="Data Source"
    choices={dataSourceOptions}
    className="input-width-xs"
    alwaysOn
    emptyText="None"
    emptyValue="None"
  />,
  <TextInput
    source="pixel_id"
    label="FB Pixel ID"
    className="input-width-md"
  />,
  <AutocompleteArrayInput
    source="account_names"
    label="Account Names"
    choices={accounts}
    optionText="name"
    optionValue="id"
    className="input-width-lg"
  />,
  <TextInput
    source="campaign_id"
    label="Campaign IDs"
    className="input-width-md"
  />,
  <AutocompleteArrayInput
    source="event_name"
    label="Event Name"
    choices={eventNames}
  />,
  <NumberInput
    source="value"
    label="Value"
    className="input-width-md"
  />,
  <NumberInput
    source="settings_id"
    label="Settings ID"
    className="input-width-xs"
  />,
  <TextInput
    source="order_id"
    label="Order IDs"
    className="input-width-md"
  />,
  <SelectInput
    source="show_historical_data"
    label="Show Historical/Regular Data"
    choices={[
      { id: true, name: 'Show Only Historical Data' },
      { id: false, name: 'Show Only Regular Data' }
    ]}
    className="input-width-md"
  />,
  <SelectInput
    source="platform_type"
    label="Platform"
    choices={PLATFORM_TYPE_CHOICES}
    className="input-width-sm"
  />,
  <SelectInput
    source="status"
    label="API Response Status"
    choices={[
      { id: 'SUCCESS', name: 'Success' },
      { id: 'ERROR', name: 'Error' },
      { id: PROCESS_STATUSES.SKIP_PROCESSING, name: 'No Response' },
      { id: 'PENDING', name: 'Pending' }
    ]}
    className="input-width-md"
  />
];

export const getMetaApiDataAggregatedFilters = () => [
  <TextInput
    source="q"
    label="ID, Pixel ID, Settings ID, Transaction ID, Campaign ID, Order ID, Event ID"
    alwaysOn
    sx={{ width: '700px' }}
  />,
  <SelectInput
    source="data_source"
    label="Data Source"
    choices={dataSourceOptions}
    className="input-width-sm"
    alwaysOn
    emptyText="None"
    emptyValue="None"
  />,
  <TextInput
    source="pixel_id"
    label="FB Pixel ID"
    className="input-width-md"
  />,
  <NumberInput
    source="settings_id"
    label="Settings ID"
    className="input-width-xs"
  />,
  <SelectInput
    source="show_historical_data"
    label="Show Historical/Regular Data"
    choices={[
      { id: true, name: 'Show Only Historical Data' },
      { id: false, name: 'Show Only Regular Data' }
    ]}
    className="input-width-md"
  />,
];
